import { computed, watch } from "vue";
import { useHostElement } from "#ce/composables/useHostElement";
import { useOptionsValue } from "#ce/composables/useOptionsValue";
import { useFinderViewCommand } from "./useFinderViewCommand";

/** Returns view-toggle options and selection mirrored with the enclosing finder. */
export function useViewToggleControl(props) {
  const host = useHostElement();
  const source = useOptionsValue();
  const { selectedValue, apply, setValue } = source;
  const { view: finderView, report: reportView } = useFinderViewCommand();

  const groupLabel = computed(() => props.label || undefined);
  const options = computed(() => source.options.value.map(withTitleOrNone));

  function withTitleOrNone(option) {
    return { ...option, title: option.title || undefined };
  }

  const inputName = computed(() => `view-toggle-${host?.id || "option"}`);

  function handleChange(event) {
    if (apply(event.target.value)) {
      reportView(event.target.value);
    }
  }

  function showFinderView(view) {
    if (view) {
      setValue(view);
    }
  }

  watch(finderView, showFinderView, { immediate: true });
  return { groupLabel, options, inputName, selectedValue, handleChange };
}
